import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-contact',
  imports: [RouterModule, FormsModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
})
export class ContactComponent {
  sent = false;
  form = { name: '', email: '', subject: 'support', message: '' };

  submit() {
    // TODO: connecter à l'API d'envoi d'email
    this.sent = true;
  }
}